import { newProjectName } from 'constant'
import { PROJECT_INCREMENT_DISABLED } from 'enums'
import { generateProjectName } from 'Util/project'
import * as API from '~/ServerAPI'

export const fetchNextProjectName = (name = newProjectName) => async () => {
  try {
    if (PROJECT_INCREMENT_DISABLED.includes(__APP_PROFILE__)) {
      return name
    }

    const rootName = name.replace(/\(\d+\)$/, '')
    const { projects } = await API.getProjects(rootName, {
      start_number: 0,
      count: 1,
      sort_field: 'createTime',
    })
    const existsProjectNames = projects.map(p => p.name)
    return generateProjectName(name, existsProjectNames)
  } catch (e) {
    console.error(`Error fetchNextProjectName: ${e}`)
    throw Error(e)
  }
}
